import { axios } from '@/services/axios';

const deleteWholesaler = async (wholesalerId) => {
    const response = await axios.delete(`/wholesaler/${wholesalerId}`);
    return response.data;
};

export default deleteWholesaler;
